import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Utils
import { actionHandler } from '../../../utilities/form/formUtils';

// Components
import Label from '../../Form/Label';
import Description from '../../Form/Description';
import Error from '../../Form/Error';

class InputCheckbox extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    const {
      values,
      id,
      variant,
      defaultValue,
      hidden,
      setValues,
    } = this.props;
    this.state = {
      isLink: variant === 'link',
      active: false,
    };

    // If Value already exists and it's true, then set to true again
    if ((Object.hasOwnProperty.call(values, id) && values[id] === true)
      || (hidden && defaultValue)) {
      this.state = {
        ...this.state,
        active: true,
      };
      if (!Object.hasOwnProperty.call(values, id) || values[id] !== true) {
        values[this.props.id] = true;
        setValues({ ...values });
      }
    }
  }

  onChange(event) {
    const {
      actions,
      dispatch,
      onChange,
      values,
      setValues,
    } = this.props;
    const { active, isLink } = this.state;
    this.setState({
      active: !active,
    });

    // If isLink then the action should be fired on the label, and not the checkbox
    if (!isLink && actions && actions.length > 0) {
      actionHandler(actions, onChange, event, dispatch, values, setValues);
    } else {
      onChange(event);
    }

    //  Push values to formVlaues coveragecode for advanced coverage templete
    if (this.props.name !== this.props.id) {
      let coverage = values[this.props.name];
      if (!coverage || coverage.constructor !== Array) {
        coverage = [];
      }
      if (this.state.active) {
        coverage.push(this.props.id);
      } else {
        const index = coverage.indexOf(this.props.id);
        if (index > -1) {
          coverage.splice(index, 1);
        }
      }
      values[this.props.name] = coverage;
      values[this.props.id] = true;
      setValues({ ...values });
    }
  }

  render() {
    const {
      actions,
      dispatch,
      id,
      name,
      label,
      onBlur,
      desc,
      descMore,
      required,
      touched,
      errors,
      hidden,
      values,
      setValues,
      variant,
    } = this.props;
    const { active } = this.state;
    const nameAssigned = !name ? id : name;
    this.props.name = nameAssigned;
    const formElementClass = classNames(
      'form__field form__field--checkbox', {
        'hidden': hidden,
      }
    );
    return (
      <div className={formElementClass}>

        {/* Error Message */}
        <Error touched={touched} errors={errors} id={id}/>

        {/* Input Field */}
        <input
          className="form__item"
          type="checkbox"
          id={id}
          name={nameAssigned}
          value={id}
          required={required}
          onBlur={onBlur}
          checked={active}
          onChange={e => this.onChange(e)}
        />

        {/* Label */}
        {label &&
        <Label
          id={id}
          label={label}
          {...(variant === 'link' ? { actions } : {})}
          dispatch={dispatch}
          values={values}
          setValues={setValues}
        />
        }

        {/* Description */}
        {desc &&
        <Description desc={desc} more={descMore} />
        }

      </div>
    );
  }
}

export default InputCheckbox;

InputCheckbox.defaultProps = {
  actions: null,
  label: null,
  desc: null,
  variant: null,
  required: false,
  name: null,
  descMore: null,
  hidden: false,
  defaultValue: false,
};

InputCheckbox.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  actions: PropTypes.object,
  variant: PropTypes.string,
  label: PropTypes.string,
  desc: PropTypes.string,
  required: PropTypes.bool,
  setValues: PropTypes.func.isRequired,
  name: PropTypes.string,
  descMore: PropTypes.object,
  hidden: PropTypes.bool,
  defaultValue: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/Steps/Input/Checkbox.jsx